$(function() {
    "use strict";

    $(document).on('ready Modal::open', function () {

        $('.fit-vid').fitVids({
            customSelector: "iframe[src^='http://rutube.ru'], iframe[src^='http://video.mail.ru']"
        });
    });

    $(document).on('Modal::open Modal::close', function (event, $modal) {
        var $fitVid = $($modal).find('.fit-vid');

        if ($fitVid.length > 0) {

            _.defer(function() {
                var $wrapper = $fitVid.children();

                $fitVid.width($fitVid.width()).height($fitVid.height());

                if (event.type == 'Modal::open') {
                    $fitVid.data('video', $wrapper);
                }

                $wrapper.remove();

                _.defer(function() {
                    $fitVid.html($fitVid.data('video'));

                    _.defer(function() {
                        $fitVid.width('').height('');
                    });

                    // Force resize of flash vids
                    setTimeout(function() {
                        $wrapper.width($wrapper.width()+1).width('');
                    }, 250)
                });
            });
        }
    });
});